import React, { useState } from "react";
import "./PasswordInput.css";

function PasswordInput({
  label,
  name,
  value,
  onChange,
  placeholder,
}) {

  const [showPassword, setShowPassword] = useState(false);

  return (

    <div className="password-group">

      <label>{label}</label>

      <div className="password-wrapper">

        <input
          type={showPassword ? "text" : "password"}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
        />

        <button
          type="button"
          className="password-toggle"
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? "🙈" : "👁"}
        </button>

      </div>

    </div>

  );
}

export default PasswordInput;